<div
  [appIsLoading]="loadingService.isLoading(this, 'message')"
  class="banner-container"
>
  <div *ngIf="message">
    <ngx-slick-carousel
      class="carousel"
      [config]="slideConfigHub"
      #slickModal="slick-carousel"
    >
      <div ngxSlickItem *ngFor="let slide of message.articles; let i = index">
        <!-- <div class="slide" carouselSlide [id]="slide.id">
          <a class="mouseOverBanner" (click)="getArticle(slide.id)">
            <div class="text-container">
              <div class="container">
                <div class="col-md-12">
                  <h2 class="cm_35 cm_reg">{{ slide.title }}</h2>
                  <p>{{ slide.teaserText }}</p>
                  <div class="btn-group">
                    <button type="button" class="btn btn-primary">
                      View More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <img
            class="img-fluid"
            [src]="slide.teaserImage"
            [alt]="slide.Title"
          />
        </div> -->
        <div class="banner-container-inner">
          <!-- <div class="banner-teaser-text">
            <h2>{{ slide.title }}</h2>
            <p>{{ slide.teaserText }}</p>
            <div class="btn-group margin-top-10">
              <button type="button" class="btn btn-primary customBtnSearch" (click)="getArticle(slide.id)" ><strong>View More</strong></button>
            </div>
          </div> -->
          <img
            class="img-fluid background-img"
            [src]="slide.teaserImage"
            [alt]="slide.Title"
          />
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</div>
